import { Component, Input } from '@angular/core';
import { Flight } from 'src/app/core/models/itinerary.model';

@Component({
  selector: 'app-segment-resume-comparision',
  templateUrl: './flights-resume.component.html'
})
export class FlightsResumeComponent {
  @Input() rescheduledOriginalFlights: Flight[];
  @Input() rescheduledRecommendationFlights: Flight[];

  constructor() {}
}
